import React, { useEffect, useState } from "react";
import axios from "axios";
import Window from "../../../../elements/window";
import Loader from "../../../../../settings/loader";
import Slide1 from "./slides/slide1";

function DeletionSales(props) {
  const [data, setData] = useState({
    deletion: {
      data: [],
      state: false,
    },
    currency: {
      base: {},
      state: false,
    },
    state: false,
  });
  const [load, setLoad] = useState(0);

  // Fetch deletion data
  const getData = async (headers, callback) => {
    let { base64 } = props.filter;
    base64 = JSON.parse(atob(base64));
    delete base64.revCent;
    base64 = btoa(JSON.stringify(base64));
    try {
      const response = await axios.post(
        props.chimeraserv.urlGet + "/deletion/set/0/",
        { id: base64 },
        { headers }
      );
      callback(response.data);
    } catch (error) {
      callback([]);
    }
  };

  // Fetch currency data
  const getCurrency = async (headers, callback) => {
    try {
      const response = await axios.get(props.chimeraserv.urlGet + "/group", {
        headers,
      });
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch (error) {
      callback([]);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    if (props.user.data) {
      const headers = {
        Authorization: props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      getData(headers, (delData) => {
        setData((prev) => ({
          ...prev,
          deletion: {
            data: delData,
            state: true,
          },
        }));
      });

      getCurrency(headers, (currencyData) => {
        const array = [];
        const currency = currencyData
          .map((group) => group.baseCurr)
          .filter((curr) => !array.includes(curr));
        setData((prev) => ({
          ...prev,
          currency: {
            base: currency.length ? currency[0]?.toUpperCase() : "QAR",
            state: true,
          },
        }));
      });
    }
    // eslint-disable-next-line
  }, [props.user.data]);

  // Set state when all data is loaded
  useEffect(() => {
    if (data.deletion.state && data.currency.state && !load) {
      setData((prev) => ({
        ...prev,
        state: true,
      }));
      setLoad(1);
    }
  }, [data.deletion.state, data.currency.state, load]);

  return (
    <section>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <Window
            user={props.user}
            chimeraserv={props.chimeraserv}
            title={"Deletions"}
          >
            <Slide1
              {...props}
              user={props.user}
              chimeraserv={props.chimeraserv}
              filter={props.filter}
              data={data}
            />
          </Window>
        </div>
      )}
    </section>
  );
}

export default DeletionSales;
